export default __webpack_public_path__ + "static/media/teamwork.ffc81816.svg";